import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import CheckboxStyles from '@stories/Components/Inputs/Checkbox/Checkbox.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const FilterItem = styled(m.div) `
  position: relative;
  color: ${brand.primary.blue};
`;
const FilterLabel = styled(m.button) `
  ${ButtonReset};
  ${transition('border-radius')};
  ${fonts.apparat.bold};

  font-size: ${fluid(16, 18)};
  padding: 7px ${fluid(46, 64)} 7px ${fluid(24, 42)};
  margin: 0;
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  overflow: hidden;
  text-transform: uppercase;
  background-color: ${brand.white};
  border-radius: 50px;
  color: currentColor;
  height: ${fluid(45, 54)};
  border: 2px solid currentColor;

  @media ${from(Device.Tablet)} {
    padding: 7px ${fluid(24, 39)};
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  &[aria-expanded='true'] {
    border-radius: 25px 25px 0 0;
  }
`;
const FilterItemIcon = styled(m.span) `
  display: block;
  flex: 0 0 auto;
  width: 8px;
  height: 15px;
  margin-left: auto;
  color: currentColor;

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;
const FilterItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;
`;
const FilterItemBodyInner = styled.div `
  --shadowColour: rgba(0, 0, 0, 0.05);
  --borderColor: rgba(0, 0, 0, 0.25);

  position: absolute;
  top: 100%;
  background-color: ${brand.white};
  z-index: 2;
  width: 100%;
  box-shadow: -0.1px 1px 1.1px var(--shadowColour), -0.2px 2.7px 3px -0.8px var(--shadowColour),
    -0.4px 6.3px 7.1px -1.7px var(--shadowColour), -0.9px 15px 16.9px -2.5px var(--shadowColour);
  border: 1px solid var(--borderColor);
  border-top: 0;
  border-radius: 0 0 25px 25px;
  padding: 0;
  overflow: hidden;
`;
const FilterGroupButton = styled.button `
  ${ButtonReset};
  ${fonts.apparat.semiBold};

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid var(--borderColor);
  margin: 0;
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(20, 24)};
  text-transform: uppercase;
  color: ${brand.black};
`;
const FilterGroupButtonIcon = styled.span `
  position: relative;
  display: block;
  width: ${fluid(12, 14)};
  aspect-ratio: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background-color: currentColor;
  }

  &::after {
    ${transition('transform')};

    ${FilterGroupButton}[data-open='false'] & {
      transform: translateY(-50%) rotate(90deg);
    }
  }
`;
const CheckboxList = styled.div `
  ${scrollbars};

  max-height: 400px;
  overflow: auto;

  ${FilterGroupButton},
  ${CheckboxStyles.Container} {
    padding: ${fluid(8, 10)} ${fluid(24, 32)};
    margin: 0;
    border-bottom: 1px solid var(--borderColor);

    @media ${from(Device.Tablet)} {
      padding: ${fluid(8, 10)} 10px;
    }

    @media ${from(Device.DesktopSmall)} {
      padding: ${fluid(8, 10)} ${fluid(24, 32)};
    }
  }

  ${FilterItemBody}:last-of-type ${CheckboxStyles.Container}:last-of-type {
    border: 0;
  }

  ${CheckboxStyles.CheckboxText} {
    padding: 2px 0 0 37px;

    &::before {
      height: 21px;
      width: 21px;
      border-radius: 2px;
    }

    @media ${until(Device.Tablet)} {
      padding: 0 32px 0 0;

      &::before,
      &::after {
        display: none;
      }
    }
  }

  &[data-size='large'] ${CheckboxStyles.Tick},${CheckboxStyles.Tick} {
    left: 4px;
    width: ${fluid(12, 14)};

    @media ${until(Device.Tablet)} {
      left: auto;
      right: 0;
    }
  }
`;
const DropdownFilterStyles = {
    CheckboxList,
    FilterItem,
    FilterItemBody,
    FilterItemBodyInner,
    FilterItemIcon,
    FilterLabel,
    FilterGroupButton,
    FilterGroupButtonIcon,
};
export default DropdownFilterStyles;
